module.exports = __webpack_public_path__ + "static/media/long-term-illness.0ece5931.jpg";